<template>
  <div>
    <div class="top-ctn">
      <div class="first" @click="selectTitle(intro)">
        <p5-title class="title" content="Introduction" size="extra-large" :animation="true" font_color="#000" selected_font_color="#000" selected_bg_color="#ff002200"></p5-title>
      </div>
      <div class="second" @click="selectTitle(hobby)">
        <p5-title class="title" content="Hobbies" size="extra-large" :animation="true" font_color="#000" selected_font_color="#000" selected_bg_color="#ff002200"></p5-title>
      </div>
      <div class="third" @click="selectTitle(link)">
        <p5-title class="title" content="Contact" size="extra-large" :animation="true" font_color="#000" selected_font_color="#000" selected_bg_color="#ff002200"></p5-title>
      </div>
    </div>
    <div class="home_ctn" v-show="navigation">
      <div class="name">
        <p5-title class="title" content="コウハクセイ" size="extra-large" font_color="#fff" selected_font_color="#fff"></p5-title>
      </div>
      <div class="name_hanzi">
        <p5-title class="title" content="HuangBaiQing" size="extra-large" font_color="#000" selected_font_color="#000"></p5-title>
      </div>
    </div>
    <div class="ctn" v-show="!navigation">
      <Intro v-show="titleLabel=='intro'"/>
      <Hobby v-show="titleLabel=='hobby'"/>
      <Link v-show="titleLabel=='link'"/>
    </div>
  </div>
</template>

<script>
import Intro from './Intro.vue'
import  Hobby from './Hobbies.vue'
import Link from './Links.vue'
export default {
  name: 'Home',
  components: {
    Intro,
    Hobby,
    Link
  },
  props: {
    msg: String
  },
  data() {
    return {
      navigation: true,
      titleLabel:"intro",
      intro:"intro",
      hobby:"hobby",
      link:"link",
    }
  },
  methods: {
    selectTitle(val){
      this.navigation = false;
      this.titleLabel = val;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg{
  width: 100vw;
  height: 100vh;
  padding: 0;
  margin: 0;
  background: url("../assets/bg.png");
  background-color: #000;
  display: flex;
  justify-content: center;
}
.top-ctn{
  position: fixed;
  display: flex;
  width: 100vw;
  height: 80px;
  top: 0;
  left: 0;
  z-index: 99;
  background: url("../assets/top.png") no-repeat;
  background-size: cover;
  color: #000;
  text-shadow: 0 3px #fff, 3px 0 #fff, -3px 0 #fff, 0 -3px #fff;
  text-align: center;
}
.top-ctn .p5-title-ctn span{
  background:rgba(0, 0, 0, 0.8);
}

.top-ctn .first{
  position: relative;
  top: 15px;
  left: 483px;
  transform: rotate(-4deg);
}
.top-ctn .second{
  position: relative;
  top: 8px;
  left: 683px;
  transform: rotate(-4deg);
}
.top-ctn .third{
  position: relative;
  top: 0px;
  left: 883px;
  transform: rotate(-4deg);
}
.top-ctn .text-size-extra-large{
  font-size: 32px;
}
.top-ctn .title:hover{
  cursor:pointer
}
.home_ctn{
  width: calc(100vw - 880px);
  height: calc(100vh - 40px);
  margin: 40px 440px 0 440px;
  display: flex;
  position: relative;
  background: url("../assets/navi.png") no-repeat;
  background-size: cover;
}
.home_ctn .name{
  position: relative;
  top: 266px;
  left: 727px;
  color: #fff;
  text-shadow: 0 2px #000, 2px 0 #000, -2px 0 #000, 0 -2px #000;
  text-align: center;
  height: 40px;
}
.home_ctn .name_hanzi{
  position: relative;
  top: 369px;
  left: 543px;
  color: #000;
  text-shadow: 0 2px #fff, 2px 0 #fff, -2px 0 #fff, 0 -2px #fff;
  text-align: center;
  height: 40px;
  transform: rotate(10deg);
}
.home_ctn .name_hanzi .text-size-extra-large{
  font-size: 32px;
}
.ctn{
  width: calc(100vw - 480px);
  height: calc(100vh - 40px);
  margin: 40px 320px 0 80px;
  display: flex;
  position: relative;
  background: url("../assets/phone.png") no-repeat;
  background-size: cover;
}
</style>
